import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import FeaturesBar from "../components/FeaturesBar";
import AboutSection from "../components/AboutSection";
import PhilosophySection from "../components/PhilosophySection";
import SolutionsSection from "../components/SolutionsSection";
import SaunasSection from "../components/SaunasSection";
import GallerySection from "../components/GallerySection";
import ValuesSection from "../components/ValuesSection";
import BackToRootsSection from "../components/BackToRootsSection";
import ProcessPreview from "../components/ProcessPreview";
import AboutPreview from "../components/AboutPreview";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <Hero />
      <FeaturesBar />
      <AboutSection />
      <PhilosophySection />
      <SolutionsSection />
      <SaunasSection />
      <GallerySection />
      <ValuesSection />
      <BackToRootsSection />
      <AboutPreview />
      <ProcessPreview />
      <ContactSection />
      <Footer />
    </div>
  );
}